/* import __COLOCATED_TEMPLATE__ from './categories.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./categories.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());